import React, {useState} from "react";
import Modal from "react-modal";
import LiquidityBableChart from "./LiquidityBableChart";

const LiquidityPopup = ({ modalIsOpen, closeModal }) => {
  const [activeTab, setActiveTab] = useState('tab1');
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  return (
  <>
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="Modal">
      <div className="My__Overlay">
        <div className="My__OverlayIn p-0">
          <div className="UFOSEC popupcenter ">
            <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal}><span className="underline">Close</span> <img src="./images/XCircle.svg" className="img-fluid" /></button>
              <div className="text-center"><h2 className="mb-0 mt-3  w-100 good_times goldFont">UFO Liquidity</h2></div>
              <div className="managePollHeight"> <LiquidityBableChart width={1200} height={800}/></div>
            </div>
        </div>
      </div>
    </Modal>
    </>
  );
};

export default LiquidityPopup;